/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import t from"./SunLighting.js";import e from"./VirtualLighting.js";const i={key:"type",defaultKeyValue:"sun",base:null,typeMap:{sun:t,virtual:e}};export{i as lightingTypes};
